import useAppSelector from 'hooks/useAppSelector';

const useStackedCalendarVisibleProperties = () => {
  return useAppSelector((state) => state.stackedCalendar.visibleProperties);
};

export default useStackedCalendarVisibleProperties;
